export default "__VITE_ASSET__LOxw9dAy__"